import React from 'react'; // Removed useState from here
import logo from '../assets/logo.png';

const Navbar = () => {
  const products = [
    "Fractional General Counsel",
    "DPDP Implementation",
    "Whistleblower and POSH",
    "Labor Codes Deployment",
    "Regulatory and Secretarial Compliances",
    "Estate Planning"
  ];

  return (
    <nav className="w-full bg-[#0B2E46] border-b border-white/10 py-4 px-8 flex justify-between items-center sticky top-0 z-[90]">
      {/* Logo Section */}
      <div className="flex items-center gap-4">
        <img 
          src={logo} 
          alt="LCaaS Logo" 
          className="h-10 w-auto object-contain" 
        />
      </div>
      
      {/* Navigation Links */}
      <div className="hidden md:flex gap-8 items-center">
        
        {/* Practice Areas */}
        <a href="#practice-areas" className="text-[14px] text-white/80 hover:text-[#78BE20] transition-colors font-medium">
          Practice Areas
        </a>

        {/* Our Products Dropdown */}
        <div className="relative group">
          <button className="flex items-center gap-1 text-[14px] text-white/80 group-hover:text-[#78BE20] transition-colors font-medium py-2">
            Our Products
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 transition-transform group-hover:rotate-180" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          {/* Dropdown Menu */}
          <div className="absolute left-0 top-full hidden group-hover:block w-72 bg-[#0B2E46] border border-white/10 shadow-xl rounded-md overflow-hidden">
            <div className="py-2">
              {products.map((product, index) => (
                <a
                  key={index}
                  href={`#${product.toLowerCase().replace(/\s+/g, '-')}`}
                  className="block px-4 py-3 text-[13px] text-white/80 hover:bg-[#153e5c] hover:text-[#78BE20] transition-colors border-b border-white/5 last:border-none"
                >
                  {product}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* About LCaaS */}
        <a href="#about" className="text-[14px] text-white/80 hover:text-[#78BE20] transition-colors font-medium">
          About LCaaS
        </a>

        {/* Resources */}
        <a href="#resources" className="text-[14px] text-white/80 hover:text-[#78BE20] transition-colors font-medium">
          Resources
        </a>

        {/* Contact Us */}
        <a href="#contact" className="text-[14px] text-white/80 hover:text-[#78BE20] transition-colors font-medium">
          Contact Us
        </a>

        {/* Careers */}
        <a href="#careers" className="text-[14px] text-white/80 hover:text-[#78BE20] transition-colors font-medium">
          Careers
        </a>

      </div>
    </nav>
  );
};

export default Navbar;